import { FC } from 'react';

import styles from './RightColumnContainer.module.scss';

type Props = {
  fullWidth?: boolean;
  noHeader?: boolean;
};

const RightColumnContainer: FC<Props> = ({ fullWidth, noHeader, children }) => {
  return (
    <div className={`${styles.container} ${fullWidth ? styles.fullWidth : ''} ${noHeader ? styles.noHeader : ''}`}>
      {children}
    </div>
  );
};

export default RightColumnContainer;
